import SliderComponent from './SliderComponent';
import TopNewsComponent from './TopNewsComponent';
import NewsGroupComponent from './NewsGroupComponent';
import AsideStaticGroupComponent from './AsideStaticGroupComponent/load';
import OneDayBookSliderComponent from './OneDayBookSliderComponent/load';
import NewsStreamComponent from './NewsStreamComponent';
import AdComponent from './AdComponent';
import ChannelReadingComponent from './ChannelReadingComponent';

export default {
    SliderComponent,
    TopNewsComponent,
    NewsGroupComponent,
    AsideStaticGroupComponent,
    OneDayBookSliderComponent,
    NewsStreamComponent,
    AdComponent,
    ChannelReadingComponent,
};
